<template>
  <div class='ProdCaracter'>
    <div
    v-for="(data, key) in ItemSelected01.caracter"
    :key="key"
    class="caracter"
    >
      <component :is="data.icon ? data.icon : 'PointIcon'"/> 
      <div class="cont-data">
        {{ data.name }} {{ data.icon === 'AreaIcon' ? 'm²' : '' }}
      </div>
    </div>  
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import PointIcon from '../../Icons/PointIcon'
import LocationIcon from '../../../EnbPainel/Icons/LocationIcon'
import RoomsIcon from '../../../EnbPainel/Icons/RoomsIcon'
import ToiletIcon from '../../../EnbPainel/Icons/ToiletIcon'
import ParkingIcon from '../../../EnbPainel/Icons/ParkingIcon'
import AreaIcon from '../../../EnbPainel/Icons/AreaIcon'
export default {
  name: 'ProdCaracter',
  components: { PointIcon, LocationIcon, RoomsIcon, ToiletIcon, ParkingIcon, AreaIcon },
  computed: {
    ...mapGetters(['ItemSelected01'])
  }
}
</script>

<style scoped>
.ProdCaracter {
  padding-top: 2%;
  text-align: left;
  font-weight: bold;
}

.caracter {
  display: flex;
  align-items: center;
  margin-top: 2%;
}

.cont-data {
  padding-left: 2%;
}
</style>
